
window.MDB = window.MDB || {};
MDB.Mangl = MDB.Mangl || {};
MDB.Mangl.Agent = MDB.Mangl.Agent || {};
(function (Agent) {
    var disablePopup = true;

    Agent.boot = function () {
        $('body').addClass('mangl mangl-adb');
        var agentDashboard = $('.mangl-agent-dashboard');
        if (agentDashboard.length > 0) {
            // agent dashboard specific stuff here

            MDB.ajax({
                url: MDB.getRoot() + 'MANGL/Agent/GetRankAndProgress',
                success: function (data) {
                    MDB.Mangl.Agent.setPerk(data.perk);
                    MDB.Mangl.Agent.setProgress(data.progress, data.perk);
                },
                error: function (data, state) {
                    console.error('Error getting data from API, response: ' + state, data);
                }
            });

            Agent.initPerkHover();
            Agent.initProgressPopupToggle();

        }
    };

    Agent.setProgress = function (percentage, perk) {
        var width;

        if (percentage < 0) {
            perk = 1;

            var arrowBorderMatchResult = /(\d+)px/.exec($('.user-progress-indicator > .arrow').css('border-bottom-width'));
            var arrowBorderOffset = 0;

            if (arrowBorderMatchResult && arrowBorderMatchResult.length > 1) {
                arrowBorderOffset = parseInt(arrowBorderMatchResult[1]);
            }

            var arrowLeft = $('.mangl .user-progress-indicator > .arrow')[0].getBoundingClientRect().left;
            var progressRowLeft = $('.perks-progress')[0].getBoundingClientRect().left;

            var width = ((arrowLeft - progressRowLeft) + arrowBorderOffset) + 'px';
        } else{
            width = Math.ceil(percentage) + '%';
        }

        $('.perks-progress .p-inner').css({ 'width': width });
    };

    Agent.setPerk = function (perk) {
    	Agent.activePerk = perk;

    	var target = $('.mangl .perk.p-' + perk);
        var indicator = $('.user-progress-indicator');
        indicator.detach().show().appendTo(target);
    };

    Agent.initPerkHover = function() {
        //Agent.initPerkHover
        var timeout=false,
            activePerk = -1,
            container = $('.mangl-agent-dashboard .row');

        var closePerk = function (nr) {
            $('.perks-popup-' + nr).hide();
        };
        var showPerk = function (nr) {
            $('.perks-popup-' + nr).show();
        };


        container.on('mouseover',
            '.info',
            function (e) {
                var me = $(this);
                if (timeout) {
                    clearTimeout(timeout);
                }
                timeout = false;

                var perkNr = me.parents('.perk').data('perk');
                if (activePerk > -1 && perkNr != activePerk) {
                    closePerk(activePerk);
                }
                activePerk = perkNr;
                //console.log('open');
                //console.log(me)
                showPerk(activePerk);
            });
        container.on('mouseout',
            '.info',
            function (e) {
                var me = $(this);
                var perkNr = me.parents('.perk').data('perk');
                timeout = setTimeout(function () {
                    //activePerk
                    closePerk(perkNr || activePerk);
                },250);;
            });

        Agent.getActivePerk = function(){
            return activePerk;
        }
    };

    Agent.initProgressPopupToggle = function () {
        if(disablePopup){
            $('.mangl-adb .user-progress-indicator').css({
                'cursor': 'initial'
            });

            return;
        }

        $('.mangl-adb').on('click', '.user-progress-indicator', function () {
            Agent.toggleProgressPopup($('.mangl.mangl-agent-dashboard.container-fluid'));
        });
    }

    Agent.toggleProgressPopup = function (mainContainer) {
        var popupContainer = mainContainer.find('.progress-popup');

        if (getProgressPopupState(popupContainer) !== 'shown') {
            Agent.displayProgressPopup(mainContainer, popupContainer);
        } else {
            Agent.hideProgressPopup(popupContainer);
        }
    }

    Agent.hideProgressPopup = function (popupContainer) {
        popupContainer.addClass('hidden');
    }

    Agent.displayProgressPopup = function (mainContainer, popupContainer) {
        if (getProgressPopupState(popupContainer) === 'initial') {
        	//Ensure we only actually create the element once
            buildProgressPopup(function (popupContainer) {
        		var popupInnerMargin = 25
                    ,   popupContainerTableHeight = 450;

                popupContainer.addClass('ready');
                popupContainer.appendTo(mainContainer);


                popupContainer
                	.find('.progress-popup-inner:has(table)')
                	.filter(function(){
                		return $(this).find('table').height() <= popupContainerTableHeight;
                	})
                	.css({'overflow-y': 'auto'});

        		//Rescale popup height to prevent excessive whitespace at the bottom
        		var tableHeights = popupContainer.find('table').map(function(){
                    var $this = $(this);
                    return $this.height() + $this.position().top;
                }).get();

        		popupContainer.height(Math.max.apply(null, tableHeights) + popupInnerMargin)
            });
            return;
        }

        popupContainer.removeClass('hidden');
    }

    function getProgressPopupState(popupContainer) {
        if (!popupContainer || !popupContainer.hasClass('ready')) {
            return 'initial';
        } else if (popupContainer.hasClass('hidden')) {
            return 'hidden';
        }

        return 'shown';
    }

    function buildProgressPopup(callback) {
        loadProgressPopupData(function (success, data) {
            if (!success) {
                return;
            }

            var popup = $('<div />', {
                class: 'progress-popup perks-popup-' + Agent.activePerk
            });

            var header = $('<div />',{
            	class: 'header'
            });


            //Take the text from one of the existing labels
            var headerLabelText = $('.perks-popup.perks-popup-' + Agent.activePerk + ' .header').text();
            var headerLabel = $('<label />', {
            	class: 'label label1'
            })
            	.appendTo(header)
            	.text(headerLabelText);

        	header.appendTo(popup);

            var groupings = _.groupBy(data, 'label')
                , labels = _.uniq(_.map(data, 'label'));

            labels.forEach(function (label, idx) {
                //Prevent label from showing up in the created table
                var odd = idx % 2 !== 0;

                var grouping = _.map(groupings[label], function (g) {
                    return _.omit(g, 'label');
                });

                var table = buildProgressPopupTable(grouping);
                var container = $('<div />', {
                    class: 'progress-popup-inner-container ' + (odd ? 'pull-right' : 'pull-left')
                });

                var inner = $('<div />', {
                    class: 'progress-popup-inner'
                });

                $('<label />', {
                    class: 'progress-popup-inner header label'
                })
                    .appendTo(container)
                    .text(label);
                
                table.appendTo(inner);
                inner.appendTo(container);
                container.appendTo(popup);
            });

            callback(popup);
        });
    }

    function loadProgressPopupData(callback) {
        MDB.ajax({
            url: MDB.getRoot() + 'MANGL/Agent/GetProgressPopupData',
            success: function (data) {
                callback(true, data);
            },
            error: function (data, state) {
                console.error('Unexpected error occurred: ' + state, data);
                callback(false, undefined);
            }
        })
    }

    function buildProgressPopupTable(data, headers) {
        var table = $('<table />')
            , headerRow = $('<tr />')
            , tableHead = $('<thead />')
            , tableBody = $('<tbody />')
            , headers = headers || Object.keys(data[0]);

        headers.forEach(function (category) {
            $('<th />')
                .appendTo(headerRow)
                .text(category);
        });

        data.forEach(function (item) {
            var row = $('<tr />');

            headers.forEach(function (category) {
                $('<td />')
                    .appendTo(row)
                    .text(item[category]);
            });

            row.appendTo(tableBody);

        });

        headerRow.appendTo(tableHead);
        tableHead.appendTo(table);
        tableBody.appendTo(table);

        return table;
    }
})(MDB.Mangl.Agent);
